import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "participants-editor" }
const _hoisted_2 = { class: "participants-editor__scroller" }
const _hoisted_3 = { class: "participants-editor__buttons" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SelectableParticipant = _resolveComponent("SelectableParticipant")
  const _component_BreakoutRoomItem = _resolveComponent("BreakoutRoomItem")
  const _component_IconTrashCanOutline = _resolveComponent("IconTrashCanOutline")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")
  const _component_Reload = _resolveComponent("Reload")
  const _component_DotsCircle = _resolveComponent("DotsCircle")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_NcActions = _resolveComponent("NcActions")
  const _component_NcDialog = _resolveComponent("NcDialog")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createVNode(_component_BreakoutRoomItem, {
        key: "unassigned",
        class: "participants-editor__section",
        name: $options.t('spreed', 'Unassigned participants')
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.unassignedParticipants, (participant) => {
            return (_openBlock(), _createBlock(_component_SelectableParticipant, {
              key: participant.attendeeId,
              checked: $data.selectedParticipants,
              "onUpdate:checked": _cache[0] || (_cache[0] = $event => (($data.selectedParticipants) = $event)),
              value: participant.attendeeId,
              participant: participant
            }, null, 8, ["checked", "value", "participant"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["name"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.assignments, (item, index) => {
        return (_openBlock(), _createBlock(_component_BreakoutRoomItem, {
          key: index,
          class: "participants-editor__section",
          name: $options.roomName(index)
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (attendeeId) => {
              return (_openBlock(), _createBlock(_component_SelectableParticipant, {
                key: attendeeId,
                checked: $data.selectedParticipants,
                "onUpdate:checked": _cache[1] || (_cache[1] = $event => (($data.selectedParticipants) = $event)),
                value: $data.assignments,
                participant: $options.attendeesById[attendeeId]
              }, null, 8, ["checked", "value", "participant"]))
            }), 128))
          ]),
          _: 2
        }, 1032, ["name"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      ($options.breakoutRoomsConfigured)
        ? (_openBlock(), _createBlock(_component_NcButton, {
            key: 0,
            class: "delete",
            title: $options.deleteButtonLabel,
            "aria-label": $options.deleteButtonLabel,
            variant: "error",
            onClick: $options.toggleShowDialog
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconTrashCanOutline, { size: 20 })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString($options.deleteButtonLabel), 1)
            ]),
            _: 1
          }, 8, ["title", "aria-label", "onClick"]))
        : _createCommentVNode("", true),
      (!$options.isReorganizingAttendees)
        ? (_openBlock(), _createBlock(_component_NcButton, {
            key: 1,
            variant: "tertiary",
            onClick: $options.goBack
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconArrowLeft, {
                class: "bidirectional-icon",
                size: 20
              })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Back')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      ($options.hasAssigned)
        ? (_openBlock(), _createBlock(_component_NcButton, {
            key: 2,
            variant: "tertiary",
            onClick: $options.resetAssignments
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_Reload, { size: 20 })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString($options.resetButtonLabel), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      ($options.hasSelected)
        ? (_openBlock(), _createBlock(_component_NcActions, {
            key: 3,
            variant: "primary",
            container: ".participants-editor__buttons",
            "menu-name": $options.t('spreed', 'Assign')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.assignments, (item, index) => {
                return (_openBlock(), _createBlock(_component_NcActionButton, {
                  key: index,
                  "close-after-click": "",
                  onClick: $event => ($options.assignAttendees(index))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_DotsCircle, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.roomName(index)), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["menu-name"]))
        : _createCommentVNode("", true),
      _createVNode(_component_NcButton, {
        disabled: !$options.hasAssigned,
        variant: $options.hasUnassigned ? 'secondary' : 'primary',
        onClick: $options.handleSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($options.confirmButtonLabel), 1)
        ]),
        _: 1
      }, 8, ["disabled", "variant", "onClick"])
    ]),
    ($data.showDialog)
      ? (_openBlock(), _createBlock(_component_NcDialog, {
          key: 0,
          open: $data.showDialog,
          "onUpdate:open": _cache[2] || (_cache[2] = $event => (($data.showDialog) = $event)),
          name: $options.t('spreed', 'Delete breakout rooms'),
          message: $options.dialogMessage,
          container: ".participants-editor"
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_NcButton, {
              variant: "tertiary",
              onClick: $options.toggleShowDialog
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.t('spreed', 'Cancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_NcButton, {
              variant: "error",
              onClick: $options.deleteBreakoutRooms
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.t('spreed', 'Delete breakout rooms')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["open", "name", "message"]))
      : _createCommentVNode("", true)
  ]))
}